import { useCallback, useEffect, useState } from 'react'
import { isParentOf } from '../dom'

export const useDropDownMenu = (
  ref: React.RefObject<HTMLDivElement | null>
) => {
  const [displayMenu, setDisplayMenu] = useState(false)

  const hideDropDownMenu = useCallback(
    (e: MouseEvent) => {
      const target = e.target as HTMLElement
      /*
          Ignore clicks on already-detached nodes — e.g. when the user picks an
          option from a nested dropdown inside a customPanel, the option is
          removed from the DOM before this handler fires, so isParentOf can't
          walk back to ref.current and would falsely close the outer dropdown.
      */
      if (!document.contains(target)) return

      const isClickInside =
        ref.current !== null && isParentOf(ref.current, target)

      if (!isClickInside && displayMenu) {
        setDisplayMenu(false)
      }
    },
    [ref.current, displayMenu]
  )

  useEffect(() => {
    if (displayMenu) {
      document.addEventListener('click', hideDropDownMenu)
    }

    return () => {
      document.removeEventListener('click', hideDropDownMenu)
    }
  }, [displayMenu])

  return {
    displayMenu,
    setDisplayMenu
  }
}
